export default __webpack_public_path__ + "static/ISO-27001-certificate-20230509-bcf2537cbcbbacc3d7749f01297a0268.pdf";